import React from 'react';

/**
 * ChannelListItem component for displaying a channel in a list
 * 
 * @param {Object} props - Component props
 * @param {string} props.primaryText - The main text to display (channel name)
 * @param {Object} props.primaryTextStyle - Style object for primary text
 * @param {string|React.ReactNode} props.secondaryText - The secondary text (online members, last message, etc.)
 * @param {React.ReactNode} props.avatar - Avatar component to display
 * @param {React.ReactNode} props.rightButton - Button to display on the right side
 * @param {Object} props.style - Style object for the entire component
 * @param {boolean} props.activeChannel - Whether this channel is currently active/selected
 * @param {string} props.className - Additional CSS class names
 * @param {function} props.onClick - Function to call when the item is clicked
 * @param {React.ReactNode} props.unreadBadge - Badge to show unread message count
 */
const ChannelListItem = ({
  primaryText,
  primaryTextStyle,
  secondaryText,
  avatar,
  rightButton,
  style = {},
  activeChannel = false,
  className = '',
  onClick = () => {},
  badge = null
}: {
  primaryText: string;
  primaryTextStyle?: React.CSSProperties;
  secondaryText?: string | React.ReactNode;
  avatar?: React.ReactNode;
  rightButton?: React.ReactNode;
  style?: React.CSSProperties;
  activeChannel?: boolean;
  className?: string;
  onClick?: () => void;
  badge?: React.ReactNode;
}) => {
  return (
    <section
      onClick={onClick}
      className={`conversationlistitem ${activeChannel ? 'active' : ''} ${className}`}
      style={style}
    >
      <div className="conversationlistitem-avatar">
        {avatar}
        {badge}
      </div>
      <div className="conversationlistitem-text">
        <h1
          className="conversationlistitem-primary-text text-ellipsis"
          style={primaryTextStyle}
        >
          {primaryText}
        </h1>
        <h2 className={`conversationlistitem-secondary-text text-ellipsis ${activeChannel ? 'active' : ''}`}>
          {secondaryText}
        </h2>
      </div>

      <div className="conversationlistitem-right-button">
        {rightButton}
      </div>
    </section>
  );
};

export default ChannelListItem;
